<div class="utf-instant-verification-container" id="utf-instant-verification">
  <picture>
    <source media="(min-width: 767px)" srcset="assets/images/verified_96.png">
    <img id="instant-verification-icon" src="assets/images/verified_96.png" alt="instant verification icon"
      tabindex="0">
  </picture>

  <div class="row no-gutters" id="instant-verification-content">
    <div class="col-md-12">
      <h1 style="display:none;">Fix for sonar issues</h1>
      <h2 id="instant-verification-heading" tabindex="0">
        {{cfetLabels.utf_instant_verification.instant_verification_heading}}<br>{{cfetLabels.utf_instant_verification.instant_verification_heading1}}
      </h2>
        <p id="instant-verification-paragraph" tabindex="0">{{cfetLabels.utf_instant_verification.instant_verification_desc}}</p>
    </div>

    <hr class='horizontal-ruler'>
    <div class="col-md-12 btn-container" id="instant-verification-footer-column">
      <a data-dismiss="modal" tabindex="0" type="button" id="cancel_link"
        class="btn btn-secondary btn-clear cancel_link" (click)="cancelCreation($event)"
        (keyup)="cancelCreation($event)"><em aria-label=""></em>
        {{cfetButtonLabels.button_labels.cancel}}</a>
      <button tabindex="0" type="button" id="btn-continue" class="btn btn-alt btn-medium"
        (click)="continueToProfileInfo($event)" (keyup)="continueToProfileInfo($event)">
        {{cfetButtonLabels.button_labels.continue}}</button>
    </div>
  </div>
</div>